var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-form-generator',{ref:"uploadForm",attrs:{"schema":_vm.schema,"model":_vm.model,"options":_vm.formOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }